/** First name only — first letter uppercase, rest lowercase. */
export function formatFirstName(name) {
  const raw = String(name ?? '').trim();
  if (!raw) return raw;
  const first = raw.split(/\s+/)[0];
  if (!first) return '';
  return first.charAt(0).toUpperCase() + first.slice(1).toLowerCase();
}
